module.exports = __webpack_public_path__ + "img/fuli_en_US_img1.8b5a9668.png";